const OfferTypeIds = {
    FIXED_RATE: "fixed_rate",
    DEFERRED_INTEREST: "deferred_interest",
    FIXED_INSTALLMENT_LOAN: "fixed_installment_loan",
    SUB_LENDER_NO_INTEREST: "sub_lender_no_interest",
    SUB_LENDER_PROMOTIONAL_RATE: "sub_lender_promotional_rate",
}

export default OfferTypeIds
